/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import InfoBoxes from './components/InfoBoxes'
import Charts from './components/Charts'
import LicensingHistoryFeature from './components/LicensingHistoryFeature'
import { Flex } from '@chakra-ui/react'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getRevenueBreakdownByAssetId } from '@/services/assets'
import { useParams } from 'react-router-dom'
import RevenueHistoryTable from './components/RevenueHistoryTable'
import CircleLoader from '@/components/loaders/CircleLoader'

const RevenueBreakdown = ({ licenseHistory }) => {
  const [selectedLicense, setSelectedLicense] = useState(null)
  const { assetId } = useParams()
  const {
    itemsResponse,
    loading
  } = useFetchItemsWithParamsV2({
    fetchService: getRevenueBreakdownByAssetId,
    fetchParams: { id: assetId }
  })

  if (loading) {
    return (
      <div className="w-full mb-5" >
        <CircleLoader />
      </div>
    )
  }

  return (
    <Flex
      flexGrow="1"
      flexDirection="column"
      gap="3"
      className="mb-5"
    >
      <InfoBoxes
        items={itemsResponse?.stats}
      />
      <Charts
        topBuyers={itemsResponse?.topBuyers}
        totalRevenue={itemsResponse?.stats.totalRevenue}
        monthlyRevenue={itemsResponse?.monthlyRevenue}
      />
      <LicensingHistoryFeature
        selectedLicense={selectedLicense}
        setSelectedLicense={setSelectedLicense}
      />
      <RevenueHistoryTable
        transactions={itemsResponse?.transactions}
      />
    </Flex>
  )
}

export default RevenueBreakdown
